/**
 * Scrolls a container so `childElement` is visible, without affecting other scroll areas.
 */
export function scrollContainerToChild(
  scrollContainer,
  childElement,
  { offset = 16, behavior = "smooth" } = {}
) {
  if (!scrollContainer || !childElement) return;

  const containerRect = scrollContainer.getBoundingClientRect();
  const childRect = childElement.getBoundingClientRect();
  const top =
    scrollContainer.scrollTop + (childRect.top - containerRect.top) - offset;

  scrollContainer.scrollTo({
    top: Math.max(0, top),
    behavior,
  });
}
